<div class="clr-row">
  <div class="clr-col-12" *ngFor="let localTree of treeForView">
    <div class="card">
      <div class="card-header">Работна карта</div>
      <div class="card-block">
        <div class="card-text">
         Ще се генерира pdf с работната карта и ще се предложи за сваляне
        </div>
      </div>
    </div>
  </div>
</div>